import SystemConfig from "../system/SystemConfig";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";

const ELEMENT_ID = "wfloader";

@injectable()
class FontPreloader {

    private _config: SystemConfig;
    private _preload: HTMLElement;

    constructor(@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig) {
        this._config = config;
    }

    initFontPreloader(parent: HTMLElement) {
        this._preload = document.createElement("div");
        this._preload.id = ELEMENT_ID;
        this._preload.style.position = "absolute";
        this._preload.style.top = "0";
        this._preload.style.left = "0";

        parent.appendChild(this._preload);
    }

    preload() {

        let gameset = this._config.gameset;

        if(gameset.game.webfonts && gameset.game.webfonts.length) {
            for(let font of gameset.game.webfonts) {
                this.addFont(font);
            }
        }

        this.addFont({className: "Ubuntu-Regular"});
        this.addFont({className: "Ubuntu-Light"});
        this.addFont({className: "Ubuntu-Bold"});
        this.addFont({className: "UbuntuMono-Regular"});
        this.addFont({className: "Audiowide-Regular"});
    }

    addFont(font: any) {
        let span = document.createElement("span");
        span.innerHTML = ".";
        this._preload.appendChild(span);

        if(typeof font === "object") {
            span.classList.add(font.className);
        } else {
            span.classList.add(font);
        }
    }

}

export default FontPreloader;
